import React from 'react';
import { PolicyLayout } from '../components/legal/PolicyLayout';

export default function PrivacyPolicy() {
  return (
    <PolicyLayout title="Privacy Policy" lastUpdated="20 February 2026">
      <p>Plus Ultra Innovation ("Plus Ultra", "we", "us", "our") operates the e-procurement and vendor-discovery platform <strong>ProcureOne Ultra</strong> available at <a href="https://www.plusultrainnovation.com" className="underline">www.plusultrainnovation.com</a>. This Privacy Policy describes how we collect, use, share and safeguard personal data of users (data principals) who visit our website, register an account, transact on the platform, or otherwise interact with our services.</p>
      <p>This Policy is governed by the <strong>Digital Personal Data Protection Act, 2023</strong> ("DPDP Act"), the <strong>Information Technology Act, 2000</strong> read with the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, and applicable Indian law.</p>

      <h2>1. Data We Collect</h2>
      <ul>
        <li><strong>Identity &amp; contact:</strong> name, email, mobile, organisation, GSTIN, PAN, address, state, city.</li>
        <li><strong>Account credentials:</strong> securely hashed password, JWT tokens, login timestamps, IP address at the time of consent.</li>
        <li><strong>Transactional data:</strong> tenders, bids, awards, invoices, payments, success-fee records.</li>
        <li><strong>Technical:</strong> device, browser, IP, referrer, audit-log telemetry needed for security and abuse prevention.</li>
        <li><strong>Documents &amp; uploads:</strong> tender documents, KYC artefacts (GST/PAN/MSME/BIS certificates), purchase orders.</li>
      </ul>

      <h2>2. Purposes of Processing</h2>
      <ul>
        <li>Account creation, authentication, and identity verification.</li>
        <li>Operating the procurement lifecycle (tendering, bidding, award, invoicing).</li>
        <li>Issuing GST-compliant tax invoices, success-fee invoices, and processing payments via Razorpay.</li>
        <li>Service communications (transactional email, alerts, support).</li>
        <li>Detecting fraud, brute-force, and other security threats; complying with court / regulatory orders.</li>
      </ul>

      <h2>3. Legal Basis &amp; Consent</h2>
      <p>We process personal data on the basis of your <strong>specific, informed and unambiguous consent</strong> captured at registration and at each payment checkout. You can withdraw consent at any time from your account settings, subject to retention obligations under tax / accounting law.</p>

      <h2>4. Sharing &amp; Disclosure</h2>
      <p>We share personal data only with: (a) <strong>Razorpay</strong> for payment processing, (b) <strong>Resend</strong> for transactional email delivery, (c) cloud storage providers for tender / KYC documents, (d) statutory authorities when legally compelled, and (e) professional advisers under confidentiality. We do not sell personal data.</p>

      <h2>5. International Transfers</h2>
      <p>Where data processors operate servers outside India, transfers occur only to jurisdictions notified by the Central Government under §16 of the DPDP Act.</p>

      <h2>6. Retention</h2>
      <p>Account data is retained while your account is active. After deletion (DPDP §12), operational data is erased within 30 days, except where retention is required by the Income Tax Act, GST Act, or any other applicable law (typically 8 years for tax records).</p>

      <h2>7. Your Rights (DPDP §11–§14)</h2>
      <ul>
        <li><strong>Right to access &amp; export</strong> your data at <a href="/privacy" className="underline">/privacy</a>.</li>
        <li><strong>Right to correction</strong> and updation via your profile page.</li>
        <li><strong>Right to erasure</strong> ("delete my account") with the phrase <code>DELETE_MY_ACCOUNT</code>.</li>
        <li><strong>Right to grievance redressal</strong> &mdash; contact the Grievance Officer below.</li>
      </ul>

      <h2>8. Security</h2>
      <p>We use industry-standard controls: bcrypt password hashing, JWT with server-side revocation, HMAC-SHA256 webhook signature verification, role-based access control, append-only audit logging, encrypted-at-rest storage, and file-upload extension + MIME whitelisting.</p>

      <h2>9. Cookies</h2>
      <p>We use first-party cookies and <code>localStorage</code> strictly for session continuity, lead-source tracking and CSRF protection. We do not run advertising trackers.</p>

      <h2>10. Children</h2>
      <p>Our services are not intended for children below 18. We do not knowingly collect data of minors.</p>

      <h2>11. Changes to this Policy</h2>
      <p>Material changes will be notified by email at least 7 days before they take effect. The version and effective date appear at the top of this page.</p>

      <h2>12. Grievance Officer (DPDP §13)</h2>
      <address className="not-italic">
        <strong>Amrapali Sawant</strong><br/>
        Grievance Officer · Plus Ultra Innovation<br/>
        H. No. 903, Manpada, Near Suresh Kirana Stores, Thane, Maharashtra &mdash; 400607<br/>
        Email: <a href="mailto:sawant.ds@gmail.com" className="underline">sawant.ds@gmail.com</a><br/>
        Response SLA: 7 working days
      </address>
    </PolicyLayout>
  );
}
